import { render } from "./PlaylistDetails.vue?vue&type=template&id=146a0264&bindings={}"
import script from "./PlaylistDetails.vue?vue&type=script&lang=ts"
export * from "./PlaylistDetails.vue?vue&type=script&lang=ts"

import "./PlaylistDetails.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script